// frontend/packages/business-console/src/components/primitives/useTokens.js
//
// Console redesign color contract accessor. Returns the active theme's
// design tokens (theme.custom.tokens), which swap automatically with
// light/dark mode. Pages read tokens through this hook instead of
// hardcoding hexes, so every surface stays consistent and a palette
// change is a single edit in theme.js.
//
// Token keys are documented at the top of src/theme.js.

import { useTheme } from '@mui/material';

export function useTokens() {
  const theme = useTheme();
  return theme.custom.tokens;
}

export default useTokens;
